var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#EFCC00","d":"M152.454545,143.045455 C120.87243,140.405868 92.1925472,123.582615 74.4764796,97.3045177 C56.760412,71.0264204 51.920866,38.1305804 61.3181818,7.86363636 C61.8791501,6.04527625 61.2480724,4.06994706 59.7367579,2.91363934 C58.2254435,1.75733163 56.1538194,1.66482186 54.5454545,2.68181818 C16.4381242,24.6314143 -3.85910573,68.08197 3.76268161,111.39319 C11.3844689,154.704409 45.2955906,188.615531 88.6068103,196.237318 C131.91803,203.859106 175.368586,183.561876 197.318182,145.454545 C198.269747,143.849358 198.143594,141.825663 197.000041,140.351082 C195.856488,138.8765 193.927877,138.25063 192.136364,138.772727 C179.304825,142.725314 165.833392,144.175846 152.454545,143.045455 Z"}));
}

Moon.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = Moon;

Moon.default = Moon;
